// Keep imports at the top per ESLint rules
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { getSiteFromHostname } from './utils/site';
import './utils/apiInterceptor'; // Interceptor para redirigir peticiones API en desarrollo

// Determine site from current hostname and store it globally
const SITE = getSiteFromHostname(window.location.hostname) || 'default';

// Make available globally as a read-only property
Object.defineProperty(window, 'SITE', {
  value: SITE,
  writable: false,
  configurable: false,
});

// Log site detection
console.log('[site] Detected SITE:', window.SITE);

// Register service worker for PWA if available
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(
      (registration) => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      },
      (err) => {
        console.log('ServiceWorker registration failed: ', err);
      }
    );
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

